(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8421],{

/***/ 1667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLinkedIn(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.909 19.412h-2.502c-.067-.253-.097-7.542-.033-8.035.787-.042 1.579-.015 2.421-.013v1l.063.009c.041-.047.085-.092.122-.137a2.73 2.73 0 012.002-1.062 3.61 3.61 0 011.74.25c.524.215.947.62 1.182 1.134.277.611.413 1.277.4 1.948.013 1.546.009 3.091.012 4.636 0 .085-.017.17-.028.274h-2.502c-.01-.147-.026-.295-.026-.443 0-1.327 0-2.653-.019-3.974a3.12 3.12 0 00-.148-.867 1.006 1.006 0 00-.83-.711 1.861 1.861 0 00-.91.046 1.111 1.111 0 00-.802.839c-.082.33-.128.666-.136 1.006-.016 1.25 0 2.499 0 3.748l-.006.352zM11.729 19.408H9.263c-.08-.237-.118-7.448-.039-8.037.822-.036 1.644-.012 2.466 0 .073.269.111 7.371.039 8.037zM10.46 7.354a1.477 1.477 0 011.484 1.448 1.498 1.498 0 01-1.507 1.472 1.46 1.46 0 11.018-2.92h.005z",
    fill: "#fff"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgLinkedIn);

/***/ }),

/***/ 68421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ withLayout; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(72276);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(78262);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(61715);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
// EXTERNAL MODULE: ./utils/store/features/userSlice.js
var userSlice = __webpack_require__(2363);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./public/logo.svg
var logo = __webpack_require__(79409);
// EXTERNAL MODULE: ./Layout/Footer/Footer.module.scss
var Footer_module = __webpack_require__(29279);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./public/Facebook.svg
var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgFacebook(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.162 20.894h-2.5c-.024-2.047 0-4.08-.017-6.148h-2.032c-.09-.262-.114-1.96-.041-2.42h2.055c.01-.153.022-.267.022-.382 0-.526-.018-1.052.008-1.577.012-.339.065-.675.158-1.001.326-1.073 1.07-1.704 2.16-1.928.607-.126 1.221-.084 1.835-.05.274.015.539.043.822.068v2.127c-.173.009-.333.018-.492.024-.382.013-.767 0-1.148.043-.496.054-.773.309-.806.8-.038.6-.01 1.2-.01 1.837.793.056 1.575-.011 2.39.038l-.312 2.4h-2.092v6.169z",
    fill: "#fff"
  })));
}
/* harmony default export */ var Facebook = (SvgFacebook);
;// CONCATENATED MODULE: ./public/Instagram.svg
var Instagram_circle, Instagram_path, _path2;
function Instagram_extends() { Instagram_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Instagram_extends.apply(this, arguments); }

function SvgInstagram(props) {
  return /*#__PURE__*/react.createElement("svg", Instagram_extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), Instagram_circle || (Instagram_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    stroke: "#fff"
  })), Instagram_path || (Instagram_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.255 20.964h0-.008a3.679 3.679 0 01-1.854-.55l-.003-.003a3.197 3.197 0 01-1.52-2.38v-.002c-.083-.701-.122-1.406-.119-2.112v-.004c-.006-1.513.01-3.027.048-4.54h0v-.01a3.7 3.7 0 01.647-2.096 3.284 3.284 0 012.371-1.394h.006c.783-.09 1.571-.13 2.36-.122v0h.004c1.514 0 3.027.014 4.535.063h.007a3.61 3.61 0 012.068.692h0a3.307 3.307 0 011.354 2.432h0l.001.01c.066.654.089 1.316.093 1.982.01 1.354.01 2.718-.027 4.07h0v.005a6.202 6.202 0 01-.209 1.504c-.353 1.242-1.18 2.003-2.447 2.332-.591.152-1.202.165-1.865.179l-.125.002c-.46.01-.898.007-1.34.004a88.064 88.064 0 00-.675-.004h-.437l.002.02c-.18-.003-.362-.007-.542-.012-.777-.017-1.55-.035-2.325-.066z",
    stroke: "#fff",
    strokeWidth: 0.794
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M18.172 14.43a3.67 3.67 0 01-3.764 3.584c-1.997-.036-3.627-1.704-3.591-3.677a3.683 3.683 0 013.743-3.57c1.995.023 3.646 1.7 3.612 3.662zm-1.297-.025c0-1.319-1.075-2.371-2.455-2.343a2.317 2.317 0 00-2.304 2.308 2.38 2.38 0 004.76.035zM18.315 11.48a.832.832 0 01-.851-.842.85.85 0 01.85-.846.845.845 0 110 1.688z",
    fill: "#fff"
  })));
}
/* harmony default export */ var Instagram = (SvgInstagram);
// EXTERNAL MODULE: ./public/LinkedIn.svg
var LinkedIn = __webpack_require__(1667);
// EXTERNAL MODULE: ./components/assets/Logo.module.scss
var Logo_module = __webpack_require__(43587);
var Logo_module_default = /*#__PURE__*/__webpack_require__.n(Logo_module);
// EXTERNAL MODULE: ./components/index.js + 25 modules
var components = __webpack_require__(60306);
// EXTERNAL MODULE: ./components/ConsentDialog/consent-configs.js
var consent_configs = __webpack_require__(44233);
;// CONCATENATED MODULE: ./Layout/Footer/Footer.jsx

















var Footer = function(_param) {
    var userStore = _param.userStore, setLoginDialogState = _param.setLoginDialogState, props = (0,_object_without_properties/* default */.Z)(_param, [
        "userStore",
        "setLoginDialogState"
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col place-content-stretch relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VintageHeader */.Ch, {
                className: (Footer_module_default()).vintageBorder,
                showHole: router.asPath === "/club" ? false : true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()((Footer_module_default()).footer, "bg-brown-background font-libre px-4")
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((Footer_module_default()).footerContent, "container flex flex-col lg:flex-row justify-between"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/",
                                        "aria-label": "Go to main BusinessClass.com page",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                                            className: (Logo_module_default()).logo
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Footer_module_default()).caption,
                                    children: "BusinessClass.com searches hundreds of travel sites at once to help you find the best premium travel offers for flights and hotels."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:flex lg:w-1/3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col justify-between lg:w-1/2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/flights/business-class",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (Footer_module_default()).link,
                                                "aria-label": "Business Class Flights",
                                                children: "Business Class Flights"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/about",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (Footer_module_default()).link,
                                                "aria-label": "About us",
                                                children: "About us"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/about/#contact",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (Footer_module_default()).link,
                                                "aria-label": "Contact",
                                                children: "Contact"
                                            })
                                        }),
                                        userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Footer_module_default()).link,
                                            onClick: function(event) {
                                                event.preventDefault();
                                                setLoginDialogState({
                                                    state: "signUp",
                                                    opened: true,
                                                    sourcePage: "Footer Newsletter"
                                                });
                                            },
                                            "aria-label": "Signup to Newsletter",
                                            children: "Newsletter"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (Footer_module_default()).link,
                                            href: "/authors",
                                            "aria-label": "Authors",
                                            children: "Authors"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col lg:w-1/2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/view/privacy_policy",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (Footer_module_default()).link,
                                                "aria-label": "Privacy Policy",
                                                children: " Privacy Policy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/view/terms_conditions",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (Footer_module_default()).link,
                                                "aria-label": "Terms & conditions",
                                                children: "Terms & conditions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/view/cookies_policy",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (Footer_module_default()).link,
                                                "aria-label": "Cookies Policy",
                                                children: "Cookies Policy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (Footer_module_default()).link,
                                            href: "/archive",
                                            "aria-label": "Archive",
                                            children: "Archive"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: classnames_default()((Footer_module_default()).link, "text-left"),
                                            type: "button",
                                            onClick: function() {
                                                return router.push({
                                                    pathname: router.pathname,
                                                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                                        cookieConsent: true
                                                    })
                                                }, undefined, {
                                                    shallow: true
                                                });
                                            },
                                            children: "Manage Consent"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start justify-between sm:mt-4 lg:mt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((Footer_module_default()).captionConnect, "w-full mb-2"),
                                            children: "Connect with us:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.facebook.com/Businessclass/",
                                                    target: "_blank",
                                                    rel: "noreferrer noopener nofollow",
                                                    "aria-label": "Open Facebook group page",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook, {
                                                        className: (Footer_module_default()).snLogo
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://instagram.com/businessclasscom",
                                                    target: "_blank",
                                                    rel: "noreferrer noopener nofollow",
                                                    "aria-label": "Open Instagram page",
                                                    className: "ml-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Instagram, {
                                                        className: (Footer_module_default()).snLogo
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.linkedin.com/company/businessclass.com",
                                                    target: "_blank",
                                                    rel: "noreferrer noopener nofollow",
                                                    "aria-label": "Open LinkedIn page",
                                                    className: "ml-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                                                        className: (Footer_module_default()).snLogo
                                                    })
                                                })
                                            ]
                                        }),
                                         false && /*#__PURE__*/ 0
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).captionConnect, "text-start pt-5"),
                                    children: [
                                        "\xa9 ".concat(new Date().getFullYear(), " BusinessClass.com   "),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "All rights reserved."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }))
        ]
    });
};

// EXTERNAL MODULE: ./Layout/Header/Header.jsx + 5 modules
var Header = __webpack_require__(8589);
// EXTERNAL MODULE: ./Layout/Layout.module.scss
var Layout_module = __webpack_require__(87480);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 112 modules
var formik_esm = __webpack_require__(28482);
// EXTERNAL MODULE: ./components/Authentication/Authentication.module.scss
var Authentication_module = __webpack_require__(28973);
var Authentication_module_default = /*#__PURE__*/__webpack_require__.n(Authentication_module);
// EXTERNAL MODULE: ./components/Authentication/components/AuthInput/AuthInput.jsx
var AuthInput = __webpack_require__(83877);
;// CONCATENATED MODULE: ./components/Authentication/components/ResetPassword/ResetPassword.jsx










var validationSchema = (0,yup_es/* object */.Ry)().shape({
    password: (0,yup_es/* string */.Z_)().required("Password is required"),
    passwordRepeat: (0,yup_es/* string */.Z_)().oneOf([
        (0,yup_es/* ref */.iH)("password"),
        null
    ], "Passwords must match").required("Repeat password is required")
});
var ResetPassword = function(param) {
    var props = param.props, token = param.token, authCompleted = param.authCompleted;
    var _$ref = (0,react.useState)(false), loading = _$ref[0], setLoading = _$ref[1];
    var _$ref1 = (0,react.useState)(false), error = _$ref1[0], setError = _$ref1[1];
    var resetPassword = function(value) {
        setLoading(true);
        (0,httpClient/* httpPost */.Ko)("/api/user/resetEmail", {
            password: value.password,
            token: token
        }).then(function(resolve) {
            if (resolve.ok) {
                setLoading(false);
                authCompleted();
            } else {
                setLoading(false);
                setError("Something went wrong, please try again later");
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            password: "",
            passwordRepeat: ""
        },
        validationSchema: validationSchema,
        onSubmit: function(values) {
            resetPassword(values);
        },
        className: "flex flex-col items-center",
        children: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    className: classnames_default()((Authentication_module_default()).passwordReset, "flex flex-col items-center"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()((Authentication_module_default()).header, "text-center my-4 font-fragment"),
                            children: "Please enter your new password"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-sm flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthInput/* AuthInput */.Y, {
                                    name: "password",
                                    type: "password",
                                    label: "Password"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                    name: "password",
                                    component: "div",
                                    className: classnames_default()((Authentication_module_default()).inputErrorMessage, "text-left")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthInput/* AuthInput */.Y, {
                                    name: "passwordRepeat",
                                    type: "password",
                                    label: "Repeat password"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                    name: "passwordRepeat",
                                    component: "div",
                                    className: classnames_default()((Authentication_module_default()).inputErrorMessage, "text-left")
                                }),
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Authentication_module_default()).loader
                                }),
                                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Authentication_module_default()).error,
                                    children: error
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: classnames_default()((Authentication_module_default()).loginButton, "text-white font-serif mx-auto my-3"),
                                    children: "Continue"
                                })
                            ]
                        })
                    ]
                }))
            });
        }
    });
};

// EXTERNAL MODULE: ./components/Authentication/components/SignUp/SignUp.jsx + 1 modules
var SignUp = __webpack_require__(59508);
// EXTERNAL MODULE: ./components/Authentication/components/PasswordRecovery/PasswordRecovery.jsx
var PasswordRecovery = __webpack_require__(12930);
// EXTERNAL MODULE: ./components/Authentication/components/SetPassword/SetPassword.jsx
var SetPassword = __webpack_require__(55311);
// EXTERNAL MODULE: ./components/Authentication/components/Login/Login.jsx
var Login = __webpack_require__(88462);
// EXTERNAL MODULE: ./components/FlightSearch/FlightSearchAutocomplete/FlightSearchAutocomplete.jsx
var FlightSearchAutocomplete = __webpack_require__(57907);
;// CONCATENATED MODULE: ./Layout/hooks/showSignUp.jsx


var frontPageDelay = 1000 * 30;
var commonDelay = 1000 * 8;
var showSignUp = function() {
    var ref = (0,react.useState)(0), dialogCount = ref[0], setDialogCount = ref[1];
    var ref1 = (0,react.useState)(false), showDialog = ref1[0], setShowDialog = ref1[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        // Get the dialog count from session storage
        var sessionDialogCount = sessionStorage.getItem("bc_signUpdialogCount");
        if (sessionDialogCount) {
            setDialogCount(parseInt(sessionDialogCount, 10));
        }
    }, []);
    (0,react.useEffect)(function() {
        // Update session storage whenever dialogCount changes
        sessionStorage.setItem("bc_signUpdialogCount", dialogCount);
        // Show dialog only if count is less than 2
        if (dialogCount < 2) {
            var timeout;
            if (router.pathname === "/") {
                timeout = setTimeout(function() {
                    setShowDialog(true);
                }, frontPageDelay);
            } else {
                timeout = setTimeout(function() {
                    setShowDialog(true);
                }, commonDelay);
            }
            return function() {
                return clearTimeout(timeout);
            };
        } else {
            setShowDialog(false);
        }
    }, [
        dialogCount,
        router.pathname
    ]);
    var incrementDialogCount = function() {
        setDialogCount(function(prevCount) {
            return prevCount + 1;
        });
    };
    return {
        showDialog: showDialog,
        incrementDialogCount: incrementDialogCount
    };
};
/* harmony default export */ var hooks_showSignUp = (showSignUp);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Switch/Switch.js + 1 modules
var Switch = __webpack_require__(45843);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./components/ConsentDialog/ConsentDialog.module.scss
var ConsentDialog_module = __webpack_require__(96098);
var ConsentDialog_module_default = /*#__PURE__*/__webpack_require__.n(ConsentDialog_module);
;// CONCATENATED MODULE: ./components/ConsentDialog/ConsentDialog.jsx
















var theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#0a0a0a"
    }
});
var IOSSwitch = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, (0,_object_spread/* default */.Z)({
        focusVisibleClassName: ".Mui-focusVisible",
        disableRipple: true
    }, props));
})(function(param) {
    var theme = param.theme;
    return {
        width: 42,
        height: 26,
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(16px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor: "#3C6562",
                    opacity: 1,
                    border: 0
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5
                }
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d",
                border: "6px solid #fff"
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: theme.palette.grey[100]
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.7
            }
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 22,
            height: 22
        },
        "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: "#E9E9EA",
            opacity: 1,
            transition: theme.transitions.create([
                "background-color"
            ], {
                duration: 500
            })
        }
    };
});
var defaultConsent = {
    analytics: false,
    marketing: false,
    personalization: false,
    data_sharing: false
};
var ConsentDialog = function() {
    var ref = (0,react.useState)(false), consentDialogOpen = ref[0], setConsentDialogOpen = ref[1];
    var ref1 = (0,react.useState)(true), consentBannerShown = ref1[0], setConsentBannerShown = ref1[1];
    var ref2 = (0,react.useState)([]), applicableCategories = ref2[0], setApplicableCategories = ref2[1];
    var ref3 = (0,react.useState)(defaultConsent), consent = ref3[0], setConsent = ref3[1];
    var ref4 = (0,react.useState)(false), isConsentConfirmed = ref4[0], setIsConsentConfirmed = ref4[1];
    var ref5 = (0,react.useState)(false), isConsentReviewMode = ref5[0], setIsConsentReviewMode = ref5[1];
    var router = (0,next_router.useRouter)();
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var isFirstRender = (0,react.useRef)(true); // Track initial render
    var isCountryWithRegions = function(countryCode) {
        return consent_configs/* countryWithRegions.includes */.O2.includes(countryCode);
    };
    var getRegionCategories = function(regionCode) {
        var regulation = Object.keys(consent_configs/* privacyRegions */.xj).find(function(key) {
            return consent_configs/* privacyRegions */.xj[key].includes(regionCode);
        }) || "default";
        console.log("Consent regulation:", regulation);
        return consent_configs/* regionSpecificCategories */.jg[regulation] || consent_configs/* regionSpecificCategories.default */.jg["default"];
    };
    var initializeConsent = function(categories) {
        return categories.reduce(function(acc, category) {
            acc[category] = false;
            return acc;
        }, {});
    };
    var toggleConsent = function(type) {
        setConsent(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, type, !prev[type]));
        });
    };
    (0,react.useEffect)(function() {
        var cookie = document.cookie.split("; ").find(function(row) {
            return row.startsWith(consent_configs/* consentCookieName */.WJ);
        });
        if (cookie) {
            var consentFromCookie = JSON.parse(cookie.split("=")[1]);
            console.log("consentFromCookie:", consentFromCookie);
            setConsent(consentFromCookie);
            setConsentBannerShown(false);
        } else if (!consentDialogOpen && (userStore === null || userStore === void 0 ? void 0 : userStore.detectCountry)) {
            var applicableCategoriesList = getRegionCategories(userStore.detectCountry);
            setApplicableCategories([
                "general",
                "functional"
            ].concat((0,_to_consumable_array/* default */.Z)(applicableCategoriesList)));
            setConsent(initializeConsent(applicableCategoriesList));
            console.log("applicableCategoriesList:", applicableCategoriesList);
            setConsentBannerShown(true);
        }
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.detectCountry,
        consentDialogOpen
    ]);
    (0,react.useEffect)(function() {
        if (router.query["cookieConsent"]) {
            setIsConsentReviewMode(true);
            setConsentBannerShown(true);
        }
    }, [
        router
    ]);
    var isConsentRequired = function(category) {
        return applicableCategories.includes(category);
    };
    var closeConsentDialog = function() {
        setConsentDialogOpen(false);
        setConsentBannerShown(false);
        setIsConsentReviewMode(false);
        if (router.query["cookieConsent"]) {
            var routerQuery = (0,_object_spread/* default */.Z)({}, router.query);
            delete routerQuery["cookieConsent"];
            router.push({
                pathname: router.pathname,
                query: (0,_object_spread/* default */.Z)({}, routerQuery)
            }, undefined, {
                shallow: true
            });
        }
        setIsConsentConfirmed(false);
    };
    var updateTagManagerConsent = function() {
        var consentPersonalization = isConsentRequired("personalization") ? consent.personalization ? "granted" : "denied" : "granted";
        var consentData = {
            analytics_storage: isConsentRequired("analytics") ? consent.analytics ? "granted" : "denied" : "granted",
            ad_storage: isConsentRequired("marketing") ? consent.marketing ? "granted" : "denied" : "granted",
            ad_user_data: consentPersonalization,
            ad_personalization: consentPersonalization,
            personalization_storage: consentPersonalization,
            functionality_storage: "granted",
            security_storage: "granted",
            data_sharing: isConsentRequired("data_sharing") ? consent.data_sharing ? "granted" : "denied" : "granted"
        };
        console.log("Updating consent with data:", consentData);
        var cookieDate = new Date(Date.now() + 3600 * 24 * 365 * 1000);
        document.cookie = "BC-Consent-Cookie=".concat(JSON.stringify(consentData), ";path=/;expires=").concat(cookieDate.toUTCString(), ";");
        localStorage.setItem("BC-Consent-Cookie", JSON.stringify(consentData));
        dist_default().dataLayer({
            dataLayer: {
                event: "gtm_consent_update",
                consent_preferences: consentData
            }
        });
    //   ad_storage: false,  // Sets consent for storing and accessing user data related to advertising.
    //   analytics_storage: false,  // Sets consent for storing and accessing user data related to analytics.
    //   ad_user_data: false,  // Sets consent for sending user data related to advertising to Google.
    //   ad_personalization: false,  // Sets consent for personalized advertising.
    //   functionality_storage: false, // Enables storage that supports the functionality of the website or app such as language settings.
    //   personalization_storage: false, // Enables storage that supports the personalization of the website or app.
    //   security_storage: false, // Enables storage related to security such as authentication functionality, fraud prevention, and other user protection
    //   data_sharing: false, // "Do Not Sell My Data" for CCPA, CPRA, etc.
    };
    var handleConsentSave = function() {
        setConsentDialogOpen(false);
        setConsentBannerShown(false);
        localStorage.setItem(consent_configs/* consentCookieName */.WJ, JSON.stringify(consent));
        document.cookie = "".concat(consent_configs/* consentCookieName */.WJ, "=").concat(JSON.stringify(consent), ";path=/;max-age=").concat(3600 * 24 * 365, ";");
        updateTagManagerConsent();
        localStorage.setItem("bcCookieConsentShowed", true);
        window.dispatchEvent(new Event("storage"));
        if (router.query["cookieConsent"]) {
            var routerQuery = (0,_object_spread/* default */.Z)({}, router.query);
            delete routerQuery["cookieConsent"];
            router.push({
                pathname: router.pathname,
                query: (0,_object_spread/* default */.Z)({}, routerQuery)
            }, undefined, {
                shallow: true
            });
        }
        setIsConsentConfirmed(false);
    };
    (0,react.useEffect)(function() {
        var userCountry = userStore === null || userStore === void 0 ? void 0 : userStore.detectCountry;
        var userRegion = isCountryWithRegions(userCountry) ? "-".concat(userStore === null || userStore === void 0 ? void 0 : userStore.detectRegion) : "";
        var regionCode = userCountry + userRegion;
        console.log("Region Code: ", regionCode);
        var categories = getRegionCategories(regionCode);
        setApplicableCategories([
            "general",
            "functional"
        ].concat((0,_to_consumable_array/* default */.Z)(categories)));
        console.log("Consent categories: ", categories);
        setConsent(initializeConsent(categories));
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.detectCountry
    ]);
    (0,react.useEffect)(function() {
        if (isFirstRender.current) {
            isFirstRender.current = false; // Mark the first render as complete
            return; // Skip the effect on the first render
        }
        if (isConsentConfirmed && (consentBannerShown || consentDialogOpen)) {
            console.log("Consent changed:", consent);
            setConsentDialogOpen(false);
            setConsentBannerShown(false);
            handleConsentSave();
        }
    }, [
        consent,
        applicableCategories,
        isConsentConfirmed
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            consentBannerShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                theme: theme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ConsentDialog_module_default()).consentBanner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            isConsentReviewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: function() {
                                    return closeConsentDialog();
                                },
                                "aria-label": "Close",
                                className: "absolute top-2 right-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-12 gap-x-4 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:col-span-7 col-span-12 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "font-libre text-2xl text-left",
                                                children: "Our website uses cookies"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: " We use technical, analytical and marketing cookies to personalise your experience and to give you the most relevant results"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-between items-center lg:col-span-5 col-span-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                color: "secondary",
                                                type: "button",
                                                variant: "outlined",
                                                onClick: function() {
                                                    setConsent(initializeConsent(applicableCategories));
                                                    setIsConsentConfirmed(true);
                                                },
                                                children: "Reject all"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                color: "secondary",
                                                type: "button",
                                                variant: "outlined",
                                                onClick: function() {
                                                    setConsentDialogOpen(true);
                                                    setConsentBannerShown(false);
                                                },
                                                children: "Customize"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                color: "secondary",
                                                type: "button",
                                                variant: "contained",
                                                sx: {
                                                    backgroundColor: "#3C6562",
                                                    "&:hover": {
                                                        backgroundColor: "#00454A"
                                                    }
                                                },
                                                onClick: function() {
                                                    setConsent(applicableCategories.reduce(function(acc, category) {
                                                        acc[category] = true;
                                                        return acc;
                                                    }, {}));
                                                    setIsConsentConfirmed(true);
                                                },
                                                children: "Accept all"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: consentDialogOpen,
                disableEscapeKeyDown: true,
                PaperProps: {
                    style: {
                        borderRadius: 0
                    }
                },
                maxWidth: "md",
                "aria-label": "Manage your privacy preferences",
                className: (ConsentDialog_module_default()).consentDialog,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-libre p-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
                        theme: theme,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-libre my-3 text-base lg:text-2xl",
                                        children: "Manage your privacy preferences"
                                    }),
                                    isConsentReviewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        onClick: function() {
                                            return closeConsentDialog();
                                        },
                                        "aria-label": "Close",
                                        className: "ml-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "We use cookies to help you navigate efficiently and perform certain functions. We also use third-party cookies that help us analyze and understand how you use this site. These cookies will be stored in your browser only with your consent."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mb-8",
                                children: [
                                    "You can choose to enable or disable some or all of these cookies but disabling some of them may affect your browsing experience.",
                                    " ",
                                    "You can read more about each type in our",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/view/privacy_policy",
                                        className: "underline text-black",
                                        prefetch: false,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-label": "Privacy Policy",
                                            children: " Privacy Policy"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: applicableCategories.map(function(category) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "h6",
                                                            children: consent_configs/* categotiesData */.E4[category].title
                                                        }),
                                                        consent_configs/* categotiesData */.E4[category].required && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            style: {
                                                                marginLeft: "auto",
                                                                color: "#3C6562"
                                                            },
                                                            children: "Always Active"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IOSSwitch, {
                                                            checked: consent[category] || consent_configs/* categotiesData */.E4[category].required,
                                                            onChange: function() {
                                                                return toggleConsent(category);
                                                            },
                                                            name: category,
                                                            disabled: consent_configs/* categotiesData */.E4[category].required,
                                                            className: "ml-auto mr-3",
                                                            onClick: function(event) {
                                                                return event.stopPropagation();
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    children: consent_configs/* categotiesData */.E4[category].description
                                                })
                                            })
                                        ]
                                    }, category);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between flex-wrap lg:flex-nowrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        type: "button",
                                        variant: "outlined",
                                        className: "w-full lg:mr-2 mb-2",
                                        onClick: function() {
                                            setConsent(initializeConsent(applicableCategories));
                                            setIsConsentConfirmed(true);
                                        },
                                        children: "Reject all"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        type: "button",
                                        variant: "contained",
                                        className: "w-full lg:mr-2 mb-2",
                                        sx: {
                                            backgroundColor: "#3C6562",
                                            "&:hover": {
                                                backgroundColor: "#00454A"
                                            }
                                        },
                                        onClick: function() {
                                            setIsConsentConfirmed(true);
                                            handleConsentSave();
                                        },
                                        children: "Save Preferences"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        type: "button",
                                        variant: "contained",
                                        className: "w-full mb-2",
                                        sx: {
                                            backgroundColor: "#3C6562",
                                            "&:hover": {
                                                backgroundColor: "#00454A"
                                            }
                                        },
                                        onClick: function() {
                                            setConsent(applicableCategories.reduce(function(acc, category) {
                                                acc[category] = true;
                                                return acc;
                                            }, {}));
                                            setIsConsentConfirmed(true);
                                        },
                                        children: "Accept all"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ConsentDialog_ConsentDialog = (ConsentDialog);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(90813);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FlightTakeoff.js
var FlightTakeoff = __webpack_require__(92585);
// EXTERNAL MODULE: ./utils/tracking.js
var tracking = __webpack_require__(32686);
;// CONCATENATED MODULE: ./Layout/Layout.jsx



























// import Logo from '../public/logo.svg';
// import { DEALS_COUNTRIES } from '../config';







var Layout_theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#202020"
    },
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ffffff",
                    borderRadius: "10px"
                }
            }
        }
    }
});
var Authentication = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6279).then(__webpack_require__.bind(__webpack_require__, 59200));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59200)
            ];
        }
    }
});
var getUserInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var res, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/user/session")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    console.log(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getUserInfo() {
        return _ref.apply(this, arguments);
    };
}();
var Layout = function(param) {
    var children = param.children, transparentHeader = param.transparentHeader, transparentHeaderMobile = param.transparentHeaderMobile;
    var getCookie = function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == " "){
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    (0,react.useEffect)(function() {
        if (children.props.transparentHeader !== undefined) {
            setTransparentHeader(children.props.transparentHeader);
        }
    }, [
        children
    ]);
    var ref = (0,react.useState)(null), sessionState = ref[0], setSessionState = ref[1];
    var ref1 = (0,react.useState)(null), userId = ref1[0], setUserId = ref1[1];
    var ref2 = (0,react.useState)({
        accepted: false,
        opened: false
    }), cookieAccepted = ref2[0], setCookieAccepted = ref2[1];
    var ref3 = (0,react.useState)(false), dealsDialogShown = ref3[0], setDealsDialogShown = ref3[1];
    var ref4 = (0,react.useState)(transparentHeader), transparentHeaderState = ref4[0], setTransparentHeader = ref4[1];
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var firstAttempt = 10 * 1000;
    var secondAttempt = 80 * 1000;
    var ref5 = (0,react.useState)({
        state: "signUp",
        opened: false,
        customHeading: null,
        changeState: null,
        sourcePage: "Common",
        redirectOffer: null
    }), loginDialogState = ref5[0], setLoginDialogState = ref5[1];
    var ref6 = (0,react.useState)({
        state: "login",
        opened: false,
        sourcePage: "Common"
    }), dealsLoginDialogState = ref6[0], setDealsLoginDialogState = ref6[1];
    var ref7 = (0,react.useState)({
        state: "verified",
        opened: false
    }), emailVerificationDialog = ref7[0], setEmailVerificationDialog = ref7[1];
    var ref8 = (0,react.useState)({
        token: "",
        opened: false
    }), passwordResetDialog = ref8[0], setPasswordResetDialog = ref8[1];
    var ref9 = (0,react.useState)({
        opened: false
    }), airportDialog = ref9[0], setAirportDialog = ref9[1];
    var ref10 = (0,react.useState)(false), showSignUpDialog = ref10[0], setShowSignUpDialog = ref10[1];
    var ref11 = (0,react.useState)(0), windowWidth = ref11[0], setWindowWidth = ref11[1];
    var ref12 = (0,react.useState)(false), showScrollButton = ref12[0], setShowScrollButton = ref12[1];
    var ref13 = (0,react.useState)(null), nearestAirport = ref13[0], setNearestAirport = ref13[1];
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var router = (0,next_router.useRouter)();
    var authCompleted = function() {
        setLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loginDialogState), {
            opened: false
        }));
        setShowSignUpDialog(false);
        session();
    };
    var dealsAuthCompleted = function() {
        authCompleted();
        setDealsDialogShown(true);
        setDealsLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dealsLoginDialogState), {
            opened: false
        }));
        document.cookie = "ibe.dealsDialogShown=true;max-age=".concat(3600 * 24 * 182.5, ";domain=.businessclass.com");
        localStorage.setItem("dealsDialogShown", JSON.stringify(true));
        window.dispatchEvent(new Event("dealsStorage"));
    };
    var resetCompleted = function() {
        setPasswordResetDialog((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, passwordResetDialog), {
            opened: false
        }));
        session();
    };
    var childrenWithProps = react.Children.map(children, function(child) {
        // Checking isValidElement is the safe way and avoids a typescript
        // error too.
        if (/*#__PURE__*/ react.isValidElement(child)) {
            return /*#__PURE__*/ react.cloneElement(child, {
                setLoginDialogState: setLoginDialogState,
                setDealsLoginDialogState: setDealsLoginDialogState,
                authCompleted: authCompleted,
                setCookieAccepted: setCookieAccepted,
                setDealsDialogShown: setDealsDialogShown
            });
        }
        return child;
    });
    var ref14 = hooks_showSignUp(), showDialog = ref14.showDialog, incrementDialogCount = ref14.incrementDialogCount;
    (0,react.useEffect)(function() {
        if (showDialog && !(userStore === null || userStore === void 0 ? void 0 : userStore.userid) && loginDialogState.state === "setAirport") {
            setLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loginDialogState), {
                opened: true,
                state: "signUp"
            }));
        }
        if ((userStore === null || userStore === void 0 ? void 0 : userStore.userid) && (loginDialogState === null || loginDialogState === void 0 ? void 0 : loginDialogState.state) === "setAirport") {
            setLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loginDialogState), {
                opened: true,
                state: "setAirport"
            }));
        }
    }, [
        showDialog,
        userStore
    ]);
    (0,react.useEffect)(function() {
        setWindowWidth(width);
        if (width <= 1024) {
            setTransparentHeader(transparentHeaderMobile);
        } else {
            setTransparentHeader(transparentHeader);
        }
    }, [
        width
    ]);
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            // Check if the user has scrolled down the viewport height
            setShowScrollButton(window.scrollY > window.innerHeight);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!getCookie("ibe.acceptedCookie") && "true" === "true") {
            localStorage.removeItem("bcCookieConsentShowed");
        }
        var cookieState = JSON.parse(localStorage.getItem("bcCookieConsentShowed"));
        setCookieAccepted({
            accepted: cookieState,
            opened: !cookieState
        });
        session();
        // We can't run session after cookie accept as we need user country to show proper consent cookie options
        // if (cookieState) {
        //   session();
        // } else {
        //   window.addEventListener('storage', (e) => {
        //     cookieState = JSON.parse(localStorage.getItem('bcCookieConsentShowed'));
        //     if (cookieState) {
        //       session();
        //     }
        //   });
        // }
        if (!getCookie("ibe.dealsDialogShown") && "true" === "true") {
            localStorage.removeItem("dealsDialogShown");
        }
        var dealsDialogCookieState = JSON.parse(localStorage.getItem("dealsDialogShown"));
        setDealsDialogShown(dealsDialogCookieState);
        if (!dealsDialogCookieState) {
            window.addEventListener("dealsStorage", function(e) {
                dealsDialogCookieState = JSON.parse(localStorage.getItem("dealsDialogShown"));
                setDealsDialogShown(dealsDialogCookieState);
            });
        }
    }, []);
    (0,react.useEffect)(function() {
        if (+router.query.login) {
            setLoginDialogState({
                state: "login",
                opened: true,
                sourcePage: "Login url link"
            });
        }
        if (+router.query.signup) {
            setLoginDialogState({
                state: "signUp",
                opened: true,
                sourcePage: "Signup url link"
            });
        }
        if (router.query["reset-token"]) {
            setPasswordResetDialog({
                token: router.query["reset-token"],
                opened: true
            });
        }
        if (+router.query.verified) {
            setEmailVerificationDialog({
                state: "verified",
                opened: true
            });
            var tagManagerArgs = {
                dataLayer: {
                    event: "accountVerified",
                    userCountry: userStore === null || userStore === void 0 ? void 0 : userStore.country.toUpperCase(),
                    pageType: router === null || router === void 0 ? void 0 : router.pathname
                }
            };
            dist_default().dataLayer(tagManagerArgs);
        }
        if (+router.query.verifyfail) {
            setEmailVerificationDialog({
                state: "verifyfail",
                opened: true
            });
            var tagManagerArgs1 = {
                dataLayer: {
                    event: "accountVerificationFail",
                    userCountry: userStore === null || userStore === void 0 ? void 0 : userStore.country.toUpperCase(),
                    pageType: router === null || router === void 0 ? void 0 : router.pathname
                }
            };
            dist_default().dataLayer(tagManagerArgs1);
        }
        (0,tracking/* saveUtmTracking */.n)(router.query);
    }, [
        router.isReady,
        router.query
    ]);
    (0,react.useEffect)(function() {
        if (!userStore) return;
        if (userStore.isSNAuth && !userStore.userid && !localStorage.getItem("BC_preferredAirport")) {
            (0,httpClient/* httpGet */.kA)("/api/airport/autocomplete?search=".concat(userStore === null || userStore === void 0 ? void 0 : userStore.detectLocation)).then(function(response) {
                return response.json();
            }).then(function(data) {
                if (data && data.airports.length > 0) {
                    // Select the first airport as the nearest for simplicity
                    setNearestAirport(data.airports[0]);
                }
                setAirportDialog({
                    opened: true
                });
            }).catch(function() {
                console.log("Error getting nearest airport");
                setAirportDialog({
                    opened: true
                });
            });
        } else {
            setAirportDialog({
                opened: false
            });
        }
    }, [
        userStore
    ]);
    var session = function() {
        getUserInfo().then(function(userInfo) {
            var user = !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.country) ? {
                userid: null,
                country: "us",
                detectCountry: null,
                detectRegion: null,
                is_admin: null,
                currency: "USD",
                username: null,
                fullname: null,
                membershipNumber: null
            } : userInfo;
            if (user.country === "uk") {
                user.country = "gb";
            }
            dispatch((0,userSlice/* setUser */.av)(user));
            setSessionState(user);
            if (user && !user.userid && +sessionStorage.getItem("bc_popup_count") !== 1 && window.location.pathname !== "/") {
                setTimeout(function() {
                    return setShowSignUpDialog(true);
                }, 5000);
            }
            // Opens clicked offer page after authentication in a new tab
            if ((user === null || user === void 0 ? void 0 : user.userid) && loginDialogState.redirectOffer) {
                var isETGOffer = loginDialogState.redirectOffer.source === "Etraveli";
                var redirectUrl = isETGOffer ? "".concat(loginDialogState.redirectOffer.url, "$").concat(user === null || user === void 0 ? void 0 : user.membershipNumber) : loginDialogState.redirectOffer.url;
                window.open(redirectUrl, "_blank");
            }
        // if (
        //   user &&
        //   !user.userid &&
        //   +sessionStorage.getItem('bc_signUp_count') !== 2
        // ) {
        //   setTimeout(() => {
        //     setLoginDialogState({ ...loginDialogState, opened: true, state: 'signUp' });
        //     sessionStorage.setItem('bc_signUp_count', 1);
        //   }, firstAttempt);
        //   setTimeout(() => {
        //     setLoginDialogState({ ...loginDialogState, opened: true, state: 'signUp' });
        //     sessionStorage.setItem('bc_signUp_count', 2);
        //   }, secondAttempt);
        // }
        }).catch(function(err) {
            console.log(err);
            if (sessionState) {
                dispatch((0,userSlice/* setUser */.av)({}));
                setSessionState(null);
            }
        });
    };
    var topContentSignup = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Layout_module_default()).dealsDialog,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: classnames_default()((Layout_module_default()).heading, "font-libre"),
                    children: [
                        "Don’t miss out on ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Layout_module_default()).higlighted,
                            children: "exclusive"
                        }),
                        " FlightDeals!"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: "my-3 font-libre text-base lg:text-xl text-left font-normal",
                        children: [
                            "The best deals go fast. Join ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "underline",
                                href: "/club",
                                children: "The Club"
                            }),
                            " for free and be the first to receive them – direct to your inbox. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Enter your email below to make sure you never miss out again!"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-libre"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "BusinessClass.com"
                    }),
                     false && /*#__PURE__*/ 0,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "57x57",
                        href: "/assets/bc-logo-57x57.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "60x60",
                        href: "/assets/bc-logo-60x60.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "72x72",
                        href: "/assets/bc-logo-72x72.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "76x76",
                        href: "/assets/bc-logo-76x76.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "114x114",
                        href: "/assets/bc-logo-114x114.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "120x120",
                        href: "/assets/bc-logo-120x120.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "144x144",
                        href: "/assets/bc-logo-144x144.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "152x152",
                        href: "/assets/bc-logo-152x152.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/assets/bc-logo-180x180.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "192x192",
                        href: "/assets/bc-logo-192x192.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/assets/bc-logo-32x32.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "96x96",
                        href: "/assets/bc-logo-96x96.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/assets/bc-logo-16x16.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "/image/x-icon",
                        href: "/assets/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut",
                        href: "/assets/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "google-site-verification",
                        content: "kcIPUazHduiHwHhy9ojS1uAgSiXPfgSgiMN4mvapA24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "verification",
                        content: "d78abf430d4b4c2601deb16b9ce49d52"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "x-ua-compatible",
                        content: "ie=edge"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1, width=device-width"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "BusinessClass.com searches hundreds of travel sites at once to help you find the best premium travel offers for flights and hotels."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: '\n            setTimeout(() => {\n              window.$crisp = [];\n              window.CRISP_WEBSITE_ID = "4e1ff683-edd9-4793-a19d-442d18f07bc8";\n              (function() {\n                var d = document;\n                var s = d.createElement("script");\n                s.src = "https://client.crisp.chat/l.js";\n                s.async = 1;\n                d.getElementsByTagName("head")[0].appendChild(s);\n              })();\n            }, 5000)\n          '
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Layout_module_default()).layout, "bg-review-bg", "h-full", "relative"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                        handleSession: getUserInfo,
                        transparentHeader: transparentHeaderState
                    }),
                    childrenWithProps,
                    showSignUpDialog && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Layout_module_default()).signUpDialogContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Layout_module_default()).registerOverlay,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    color: "inherit",
                                    onClick: function() {
                                        setShowSignUpDialog(false);
                                        sessionStorage.setItem("bc_popup_count", 1);
                                    },
                                    "aria-label": "close",
                                    className: (Layout_module_default()).closeSignUpDialog,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function(event) {
                                        event.preventDefault();
                                        setLoginDialogState({
                                            state: "signUp",
                                            opened: true,
                                            sourcePage: "Teaser click"
                                        });
                                    },
                                    className: classnames_default()((Layout_module_default()).signUpButton, "font-fragment"),
                                    children: "Claim FREE membership of The Club"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                        open: loginDialogState.opened,
                        onBackdropClick: function() {
                            incrementDialogCount();
                            setLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loginDialogState), {
                                opened: false
                            }));
                        },
                        PaperProps: {
                            style: {
                                borderRadius: 0
                            }
                        },
                        fullScreen: windowWidth <= 520,
                        fullWidth: false,
                        maxWidth: "md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Layout_module_default()).loginDialog,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    color: "inherit",
                                    onClick: function() {
                                        incrementDialogCount();
                                        setLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loginDialogState), {
                                            opened: false
                                        }));
                                    },
                                    "aria-label": "close",
                                    className: (Layout_module_default()).closeDialog,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                                    triggerOnce: true,
                                    children: function(param) {
                                        var inView = param.inView, ref = param.ref;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: ref,
                                            className: "w-full mx-auto",
                                            children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication, {
                                                authCompleted: authCompleted,
                                                state: loginDialogState.state,
                                                customHeading: loginDialogState.customHeading,
                                                changeState: loginDialogState.changeState,
                                                sourcePage: loginDialogState.sourcePage
                                            })
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                        open: dealsLoginDialogState.opened && dealsLoginDialogState.state !== "welcome" && !(userStore === null || userStore === void 0 ? void 0 : userStore.userid) && !(loginDialogState === null || loginDialogState === void 0 ? void 0 : loginDialogState.opened),
                        onBackdropClick: function() {
                            // if(dealsLoginDialogState.state === 'welcome') {
                            //   setDealsLoginDialogState({ ...dealsLoginDialogState, opened: false });
                            // }
                            setDealsLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dealsLoginDialogState), {
                                opened: false
                            }));
                        },
                        PaperProps: {
                            style: {
                                borderRadius: 0
                            }
                        },
                        // fullScreen={windowWidth <= 420}
                        fullWidth: true,
                        maxWidth: "lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                color: "inherit",
                                onClick: function() {
                                    setDealsLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dealsLoginDialogState), {
                                        opened: false
                                    }));
                                    dealsAuthCompleted();
                                },
                                "aria-label": "close",
                                className: (Layout_module_default()).closeDialog,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                                triggerOnce: true,
                                children: function(param) {
                                    var inView = param.inView, ref = param.ref;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: ref,
                                        className: classnames_default()((Layout_module_default()).dealsDialogContainer, "w-full mx-auto"),
                                        children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "lg:w-1/2 ml-auto p-3",
                                                    children: [
                                                        dealsLoginDialogState.state === "welcome" && !dealsDialogShown && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "min-h-100",
                                                            children: [
                                                                topContentSignup,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flex mt-8 mb-8",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: classnames_default()((Layout_module_default()).proceedButton, "text-white font-serif mx-auto"),
                                                                        onClick: function() {
                                                                            setDealsLoginDialogState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dealsLoginDialogState), {
                                                                                opened: false
                                                                            }));
                                                                            dealsAuthCompleted();
                                                                        },
                                                                        children: "Proceed"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        dealsLoginDialogState.state === "login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Login/* Login */.m, {
                                                            authCompleted: dealsAuthCompleted,
                                                            changeState: function(state) {
                                                                setDealsLoginDialogState({
                                                                    opened: true,
                                                                    state: state,
                                                                    sourcePage: "FlightDeals popup"
                                                                });
                                                            },
                                                            darkMode: true,
                                                            sourcePage: "FlightDeals popup"
                                                        }),
                                                        dealsLoginDialogState.state === "signUp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUp/* SignUp */.M, {
                                                            authCompleted: dealsAuthCompleted,
                                                            customTopContent: topContentSignup,
                                                            setUserId: setUserId,
                                                            changeState: function(state) {
                                                                setDealsLoginDialogState({
                                                                    opened: true,
                                                                    state: state,
                                                                    sourcePage: "FlightDeals popup"
                                                                });
                                                            },
                                                            darkMode: true,
                                                            sourcePage: "FlightDeals popup"
                                                        }),
                                                        dealsLoginDialogState.state === "passwordReset" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordRecovery/* PasswordRecovery */.C, {
                                                            darkMode: true,
                                                            changeState: function(state) {
                                                                setDealsLoginDialogState({
                                                                    opened: true,
                                                                    state: state
                                                                });
                                                            }
                                                        }),
                                                        dealsLoginDialogState.state === "setPassword" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SetPassword/* SetPassword */.$, {
                                                            changeState: function(state) {
                                                                setDealsLoginDialogState({
                                                                    opened: true,
                                                                    state: state,
                                                                    sourcePage: "FlightDeals popup"
                                                                });
                                                            },
                                                            userId: userId,
                                                            authCompleted: dealsAuthCompleted,
                                                            darkMode: true,
                                                            sourcePage: "FlightDeals popup"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                        open: emailVerificationDialog.opened,
                        disableEscapeKeyDown: true,
                        PaperProps: {
                            style: {
                                borderRadius: 0
                            }
                        },
                        maxWidth: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Layout_module_default()).cookieDialog, "font-libre"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
                                theme: Layout_theme,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        color: "inherit",
                                        onClick: function() {
                                            return setEmailVerificationDialog((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, emailVerificationDialog), {
                                                opened: false
                                            }));
                                        },
                                        "aria-label": "close",
                                        className: (Layout_module_default()).closeDialog,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((Layout_module_default()).cookieDialogHeading, "font-garamond my-8"),
                                        children: emailVerificationDialog.state === "verified" ? "Email Verified!" : "Email verification failed!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-8",
                                        children: emailVerificationDialog.state === "verified" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                "Your email address has been verified. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Welcome to BusinessClass.com"
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "Verification link is expired. Please try once more."
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                        open: passwordResetDialog.opened,
                        disableEscapeKeyDown: true,
                        PaperProps: {
                            style: {
                                borderRadius: 0
                            }
                        },
                        maxWidth: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Layout_module_default()).cookieDialog, "font-libre"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
                                theme: Layout_theme,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        color: "inherit",
                                        onClick: function() {
                                            return setPasswordResetDialog((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, passwordResetDialog), {
                                                opened: false
                                            }));
                                        },
                                        "aria-label": "close",
                                        className: (Layout_module_default()).closeDialog,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetPassword, {
                                            token: passwordResetDialog.token,
                                            authCompleted: resetCompleted
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                        open: airportDialog.opened,
                        maxWidth: "sm",
                        disableEscapeKeyDown: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                            theme: Layout_theme,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("p-5"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Layout_module_default()).dealsDialog,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: classnames_default()("font-libre"),
                                            children: "Please select your preferred airport"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-libre text-center mb-4 text-black",
                                            children: [
                                                "We will use it as an origin point to show you personalized flight deals. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " You can update this later in your profile settings."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                            initialValues: {
                                                userAirport: nearestAirport || null
                                            },
                                            onSubmit: function(value) {
                                                var ref, ref1, ref2;
                                                if (!value.userAirport) return;
                                                var userAirport = {
                                                    code: (ref = value.userAirport) === null || ref === void 0 ? void 0 : ref.Iata,
                                                    name: (ref1 = value.userAirport) === null || ref1 === void 0 ? void 0 : ref1.ShortName,
                                                    isCity: !((ref2 = value.userAirport) === null || ref2 === void 0 ? void 0 : ref2.ParentAirport)
                                                };
                                                localStorage.setItem("BC_preferredAirport", JSON.stringify(value.userAirport));
                                                (0,httpClient/* httpPost */.Ko)("/api/user/airport", userAirport).then(function(resolved) {
                                                    if (resolved.ok) {
                                                        setAirportDialog({
                                                            opened: false
                                                        });
                                                        if (router.pathname.startsWith("/flightsearch")) {
                                                            window.open("/profile?accountCreated=true", "_blank");
                                                        } else {
                                                            router.push("/profile?accountCreated=true");
                                                        }
                                                    }
                                                    if (!resolved.ok) {
                                                        throw resolved.json();
                                                    }
                                                }).catch(function() {
                                                    var _ref = (0,_async_to_generator/* default */.Z)(function(error) {
                                                        var ref, _, _tmp;
                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    _ = console.log;
                                                                    return [
                                                                        4,
                                                                        error
                                                                    ];
                                                                case 1:
                                                                    _tmp = _state.sent().msg;
                                                                    if (_tmp) return [
                                                                        3,
                                                                        3
                                                                    ];
                                                                    return [
                                                                        4,
                                                                        error
                                                                    ];
                                                                case 2:
                                                                    _tmp = (ref = _state.sent().reason) === null || ref === void 0 ? void 0 : ref[0].msg;
                                                                    _state.label = 3;
                                                                case 3:
                                                                    _.apply(console, [
                                                                        _tmp
                                                                    ]);
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(error) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }());
                                            },
                                            className: "flex flex-col items-end",
                                            children: function(param) {
                                                var setFieldValue = param.setFieldValue, errors = param.errors, touched = param.touched, values = param.values;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearchAutocomplete/* FlightSearchAutocomplete */.s, {
                                                            setFieldValue: setFieldValue,
                                                            name: "userAirport",
                                                            label: "Preferred departure Airport",
                                                            showLabel: false,
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightTakeoff/* default */.Z, {}),
                                                            error: !!(touched.userAirport && errors.userAirport),
                                                            patch: {
                                                                value: values.userAirport
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "flex",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                color: "secondary",
                                                                variant: "contained",
                                                                type: "submit",
                                                                className: classnames_default()((Layout_module_default()).proceedButton, "text-white font-serif mt-4 mx-auto"),
                                                                children: "Continue"
                                                            })
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    showScrollButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        className: classnames_default()((Layout_module_default()).scrollToTopButton, showSignUpDialog && "bottom-14"),
                        color: "secondary",
                        onClick: function() {
                            return window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        userStore: userStore,
                        setLoginDialogState: setLoginDialogState
                    }),
                    (userStore === null || userStore === void 0 ? void 0 : userStore.detectCountry) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsentDialog_ConsentDialog, {})
                ]
            })
        ]
    });
};
var withLayout = function(Component, transparentHeader) {
    var transparentHeaderMobile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return function withLayoutComponent(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            transparentHeader: transparentHeader,
            transparentHeaderMobile: transparentHeaderMobile,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props))
        });
    };
};


/***/ }),

/***/ 32686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ saveUtmTracking; },
/* harmony export */   "x": function() { return /* binding */ getUtmSource; }
/* harmony export */ });
// Save utm to session storage for future tracking
function saveUtmTracking(query) {
    if (query["utm_source"] || query["utm_medium"] || query["utm_campaign"]) {
        sessionStorage.setItem("BC_utm_source", JSON.stringify({
            utm_source: query["utm_source"],
            utm_medium: query["utm_medium"],
            utm_campaign: query["utm_campaign"]
        }));
    } else if (query["gclid"]) {
        sessionStorage.setItem("BC_utm_source", JSON.stringify({
            utm_source: "google",
            utm_medium: "cpc"
        }));
    }
}
// Get last utm source
function getUtmSource() {
    var st = sessionStorage.getItem("BC_utm_source");
    if (!st) {
        return "organic";
    }
    var utm_source = JSON.parse(st)["utm_source"];
    if (!utm_source) {
        return "none";
    }
    return utm_source;
}


/***/ }),

/***/ 29279:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vintageBorder":"Footer_vintageBorder__SxrAW","footer":"Footer_footer__cSrNx","snLogo":"Footer_snLogo__5f30r","footerContent":"Footer_footerContent__gZCgf","link":"Footer_link__zkhjY","caption":"Footer_caption__PyWfd","captionConnect":"Footer_captionConnect__V82h_","closeDialog":"Footer_closeDialog__sEkID"};

/***/ }),

/***/ 87480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__RaDeg","cookieDialog":"Layout_cookieDialog__Ek8s5","cookieDialogHeading":"Layout_cookieDialogHeading__718Pu","signUpDialogContainer":"Layout_signUpDialogContainer__QIoug","closeSignUpDialog":"Layout_closeSignUpDialog__55RYh","registerOverlay":"Layout_registerOverlay__ekEUZ","signUpButton":"Layout_signUpButton__fGCT0","closeDialog":"Layout_closeDialog__X74wu","dealsDialogContainer":"Layout_dealsDialogContainer__4jMZb","dealsDialog":"Layout_dealsDialog__nrmEH","heading":"Layout_heading__bIm3d","higlighted":"Layout_higlighted__ivU_i","proceedButton":"Layout_proceedButton__IJVqw","scrollToTopButton":"Layout_scrollToTopButton__lRlzI"};

/***/ }),

/***/ 96098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"consentBanner":"ConsentDialog_consentBanner__3I4sX","consentDialog":"ConsentDialog_consentDialog__eIso3"};

/***/ })

}]);